"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
const ColorInput_1 = __importDefault(require("../ColorInput"));
function FormikColorPicker(props) {
    const { onColorChange = () => null, name, ...colorPickerProps } = props;
    const { values, setFieldValue } = (0, formik_1.useFormikContext)();
    const colorChangeHandler = (0, react_1.useCallback)((color) => {
        onColorChange(color);
        void setFieldValue(name, color.hex);
    }, [name, onColorChange, setFieldValue]);
    return ((0, jsx_runtime_1.jsx)(ColorInput_1.default, { ...colorPickerProps, name: name, onColorChange: colorChangeHandler, value: (0, get_1.default)(values, name) }));
}
exports.default = (0, react_1.memo)(FormikColorPicker);
